import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/finally';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { LoaderService } from './loader/loader.service';

@Injectable()
export class NetworkingService {
    public authToken : string;   
    constructor(
        private http: Http,
        private router: Router,
        private loaderService: LoaderService     
    ) { }

    get(url:string,options?:Object) : Observable<any> {

        let headers = new Headers({ 
            'Content-Type': 'application/json', 
            'Access-Control-Allow-Origin':'*'
		});        
        if(this.authToken) {
            headers.append('Authorization', this.authToken);
        }
        if(!options) {
            options = new RequestOptions({ headers: headers, withCredentials: true });
        }
        this.showLoader();
        return this.http.get(environment.apiUrl + url, options)
        .map(this.extractData)
          .catch(this.handleError.bind(this))
          //.finally(() => this.hideLoader());
        /*return this.http.get(url, options)
        .map(this.extractData)
          .catch(this.handleError);*/
    }

    post(url:string, data:any, basePath ?: string) : Observable<any> {
        
        let headers = new Headers({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin':'*' });        
        if(this.authToken) {
            headers.append('Authorization', this.authToken );
        }
        let options = new RequestOptions({ headers: headers, withCredentials: true });
        // if(!basePath) {
        //     basePath = "apiUrl";
        // }
        url = environment.apiUrl + url;
        this.showLoader();
        return this.http.post(url, data, options)
        .map(this.extractData)
          .catch(this.handleError.bind(this))
          .finally(() => this.hideLoader());
    }

    put(url:string, data:any, basePath ?: string) : Observable<any> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin':'*' });        
        if(this.authToken) {
            headers.append('Authorization', this.authToken);
        }
        let options = new RequestOptions({ headers: headers, withCredentials: true });
        // if(!basePath) {
        //     basePath = "apiUrl";
        // }
        url = environment.apiUrl + url;
        this.showLoader();
        return this.http.put(url, data, options)
        .map(this.extractData)
          .catch(this.handleError.bind(this))
          .finally(() => this.hideLoader());
    }

    getJSON(url:string) : Observable<any> {
        let headers = new Headers({ 
            'Content-Type': 'application/json', 
            'Access-Control-Allow-Origin':'*'            
        });
        this.showLoader();
        return this.http.get(url, new RequestOptions({ headers: headers, withCredentials: true}))
            .map(this.extractData)
            .catch(this.handleError.bind(this))
            .finally(() => this.hideLoader());
    }
    
    private extractData(res: Response) {        
        let body = res.json();
        if(typeof body === "string"){
            body = JSON.parse(body);
        }      
        return body;
    }

    private handleError(error: Response | any) {        
        let returnObject ={status: error.status, Error: '', statusText:''};
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.Error || JSON.stringify(body);
            returnObject.Error = err;
            returnObject.statusText = error.statusText;
            if (error.status === 403){
                return this.unauthorised();
            }
        }        
        return Observable.throw(returnObject);
    }
    
    unauthorised(): Observable<any>{
        this.router.navigate(['/externalRedirect', { externalUrl: environment.taPortal }]);
        return Observable.empty();
    }

    private showLoader() {
        this.loaderService.show();
    }

    private hideLoader() {
        this.loaderService.hide();
    }

    public showMultiLoader() {
        this.loaderService.multiShow();
    }

    public hideMultiLoader() {
        this.loaderService.multiHide();
    }
    public setAuthToken(token){
        this.authToken=token;
    }
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/shared/networking.service.ts